import React, { useState, useContext, useEffect } from 'react';
import { usersPathTo } from '../utils/Api';
import { UserContext } from '../contexts/UserContext';
import SnackbarContext from '../contexts/SnackbarContext';
import TextField from '@mui/material/TextField';
import { Box, Typography, Link, Button } from '@mui/material';
import TudoPetsLogo from '../images/tp_logo_laranja.png';
import { useNavigate } from 'react-router-dom';
import FormBox from './building_blocks/FormBox';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const { openSnackbar } = useContext(SnackbarContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser) {
      navigate('/home');
    }
  }, [currentUser, navigate]);

  useEffect(() => {
    document.title = 'Entrar - TudoPets.app';
  }, []);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    usersPathTo.login({email: email, password: password}).then(result => {
      setCurrentUser(result.data);
      localStorage.setItem('current_user', JSON.stringify(result.data))
    }, error => {
      openSnackbar(error.response.data.error, "error");
      console.log("login error", error);
    })
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    if (!email) {
      openSnackbar("Por favor, informe seu email.", "error");
      return;
    }
    usersPathTo.forgot_password({email: email}).then(result => {
      localStorage.setItem('forgot_password_email', email)
      openSnackbar("E-mail de redefinição de senha enviado, verifique sua caixa de entrada.", "success");
    }, error => {})
  }

  return (
    <FormBox>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Box display="flex" flexDirection="column"
          component="img"
          src={TudoPetsLogo}
          alt="Logo TudoPets"
          sx={{
            marginTop: '20px',
            width: '200px', 
            height: 'auto', 
          }}
        />
        {/* <Typography variant="h5">
          Login
        </Typography> */}
        <Box display="flex" flexDirection="row" justifyContent="center" >
          <form onSubmit={handleSubmit}>
            <Box mt={2}>
              <TextField label="Email" name="email" variant="outlined" type="email" value={email} onChange={handleEmailChange} fullWidth/>
            </Box>
            <Box mt={2}>
              <TextField label="Senha" name="password" variant="outlined" type="password" value={password} onChange={handlePasswordChange} fullWidth/>
            </Box>
            <Box mt={4}>
              <Button variant="outlined" type="button" onClick={() => navigate('/register')}>
                Criar conta
              </Button>
              <Button variant="contained" type="submit">Login</Button>
            </Box>
            <Box mt={2}>
              <Typography color="primary" variant="body2" >
                <Link onClick={handleForgotPassword} underline="hover">Esqueceu sua senha?</Link>
              </Typography>
            </Box>
          </form>
        </Box>
      </Box>
    </FormBox>
  );
};

export default Login;